import { colors } from '../../Colors/colors'

export const cloudCallingTheme = {
   light: {
      common: {
         defaultHeaderTextColor: 'text-gray-900',
         defaultBorderColor: 'border-gray-300'
      },
      callDetails: {
         callTitleColor: 'text-gray-700',
         callDescriptionColor: 'text-gray-600',
         callDetailsBorderColor: 'border-gray-300',
         callerPhoneNumberColor: 'text-gray-900',
         tagBorderColor: 'border-gray-300',
         tagTextColor: 'text-gray-700',
         phoneIconColor: colors['primary-600']
      },

      plugins: {
         pluginsHeader: {
            headerNameColor: 'text-gray-900',
            headerContainer: 'bg-base-white border-gray-200'
         },
         pluginsList: {
            bgColor: 'bg-gray-100',
            listBorderColor: 'border-gray-300',
            pluginTitleColor: 'text-gray-700',
            pluginDescriptionColor: 'text-gray-700',
            dotsIconColor: colors['gray-700'],
            popoverOptionsColor: 'text-gray-900',
            popoverContainerHoverBackgroundColor: 'hover:bg-gray-50'
         },
         pluginAccount: {
            createAccountButtonColor: 'bg-primary-600',
            createAccountButtonTextColor: 'text-base-white',
            plusIconFillColor: colors['base-white'],
            backButtonColor: 'text-primary-600',
            chevronLeftIconFillColor: colors['primary-600'],
            chevronIconColor: colors['gray-700'],
            headerTitleColor: 'text-gray-900',
            header: 'bg-base-white border-gray-200',
            statusToggle: {
               borderColor: 'border-gray-100',
               backgroundColor: 'bg-gray-100',
               color: 'text-gray-500',
               selected: {
                  bgColor: 'bg-base-white',
                  color: 'text-gray-700'
               },
               horizontalLineColor: 'border-gray-300'
            },
            iconFillColor: colors['gray-700']
         },
         createPluginAccount: {
            closeIconColor: colors['gray-500'],
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600',
            leftSectionBgColor: 'bg-gray-100'
         },
         uploadAgents: {
            headerTitleColor: 'text-gray-900',
            headerDescriptionColor: 'text-gray-600',
            formBorderColor: 'border-b-gray-300',
            footerTextStyles: 'text-primary-600'
         },
         pluginAccountSettings: {
            settingsTextColor: 'text-gray-900',
            borderColor: 'border-gray-300'
         }
      },
      pluginAccountDetails: {
         tableColumnHeaderColor: 'text-gray-500',
         tableContainerBgColor: 'bg-gray-100',
         tableCellNameColumnColor: 'text-gray-800',
         tableCellDataColor: 'text-gray-600'
      },
      editAgent: {
         horizontalLineColor: 'border-t-gray-200',
         deleteIconColor: colors['error-500'],
         deleteAgentTextColor: 'text-error-600',
         deleteAgentConfirmationTitleColor: 'text-gray-900',
         deleteAgentConfirmationDescriptionColor: 'text-gray-600'
      },
      notFound: {
         titleTextColor: 'text-gray-900',
         description: 'text-gray-600',
         notFoundBgColor: 'bg-gray-100'
      }
   },
   dark: {}
}
